import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_SHOP } from '@/modules/shop/router';
import { shopService } from '@/services/shop';
import { useMixins } from './mixins';

export function useShopItemEdit() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { model, v$, fetch, iapOptions } = useMixins();

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                shopService.item.update(
                    model.id,
                    model.name,
                    model.price,
                    model.credit,
                    model.isPublished,
                    model.packageId,
                    model.isBestseller,
                    model.imageFile,
                    model.thumbnailFile
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_SHOP.INDEX })
        }),

        remove: crudAction.confirmAndRemove({
            request: () => shopService.item.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_SHOP.INDEX })
        })
    };

    return { model, v$, iapOptions, fetch, actions };
}
